import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ILoginForm } from 'src/app/core/login/form-data.interface';
import { Profile } from 'src/app/shared/interfaces/index.interface';
import { JwtService } from '../index.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  readonly BASE_URL = environment.BASE_API_URL;
  public userData?:Profile | null;
  constructor(
    private http:HttpClient,
    public jwtToken:JwtService 
  ){}
  createTokenLogin(data:ILoginForm) {
    return this.jwtToken.createTokenLogin(data)
  }
  sendCodeByEmail(email:string | undefined){
    let formData = new FormData();
    let headers = this.setHeaderLanguage()
    formData.append('email',(email?.toString() as string));
    return this.http.post(`${this.BASE_URL}auth/users/reset_password/`,formData,{headers});
  }
  sendCodeByPhone(phone:string | undefined){
    let formData = new FormData();
    let headers = this.setHeaderLanguage();
    formData.append('phone_number',(phone?.toString() as string));
    return this.http.post(`${this.BASE_URL}auth/phone/reset_password/`,formData,{headers});
  }
  verifyCodeResetPasswordByEmail(email:string | undefined,code:string){
    let formData = new FormData();
    let headers = this.setHeaderLanguage()
    formData.append('email',(email?.toString() as string));
    formData.append('code',code);
    return this.http.post(`${this.BASE_URL}auth/users/reset_password_confirm/`,formData,{headers});
  }
  verifyCodeResetPasswordByPhone(phone:string | undefined,code:string){
    let formData = new FormData();
    let headers = this.setHeaderLanguage()
    formData.append('phone_number',(phone?.toString() as string));
    formData.append('code',code);
    return this.http.post(`${this.BASE_URL}auth/phone/reset_password_confirm/`,formData,{headers});
  }
  resetPassword(type:boolean,uid:string | undefined,new_password:string | undefined){
    let formData = new FormData();
    let headers = this.setHeaderLanguage()
    formData.append('uid',(uid as string));
    formData.append('new_password',(new_password as string));
    if(type){
      return this.http.post(`${this.BASE_URL}auth/users/reset_password_with_uid/`,formData,{headers});
    }else{
      return this.http.post(`${this.BASE_URL}auth/phone/reset_password_with_uid/`,formData,{headers});
    }
  }
  setHeaderLanguage(){
    let headers = new HttpHeaders(); 
    headers = headers.append('Accept-Language' , 'fa')
    return headers
  }
}